import { Center, Loader as MantineLoader } from '@mantine/core';

export default function Loader() {
  return (
    <Center p="md">
      <MantineLoader color="blue.1" size="xs" type="dots" />
    </Center>
  );
}
